import { parseCookie, stringifySetCookie } from 'cookie';

export function parseCookies(ctx = {}) {
  // Server-side
  if (ctx.req && ctx.req.headers && ctx.req.headers.cookie) {
    return parseCookie(ctx.req.headers.cookie);
  }
  // Client-side
  if (typeof document !== 'undefined') {
    return parseCookie(document.cookie);
  }
  return {};
}

export function setCookie(ctx, name, value, options = {}) {
  const res = ctx?.res || ctx;
  const serialized = stringifySetCookie({
    name,
    value,
    path: '/',
    // httpOnly: true, // no need as we set only domain key for non-prod
    secure: process.env.NODE_ENV === 'production',
    ...options
  });

  const prev = res.getHeader?.('Set-Cookie');
  res.setHeader?.('Set-Cookie', Array.isArray(prev) ? [...prev, serialized] : [serialized]);
}

export function destroyCookie(ctx, name, options = {}) {
  setCookie(ctx, name, '', {
    ...options,
    expires: new Date(0)
  });
}
